'use client';
import React, { useState, createContext, useContext, useEffect } from "react";
import { useRouter } from "next/router";
import { useAxios, handleError } from "../utils/helpers";
import { useLoop } from "../components/loop-provider";
import { Loader, useToast } from "../design";
import { translate } from "../utils/translations";
import { campaignWithUsageLimitEnabled } from "../utils/constants";

const QuickActionsContext = createContext(null);

export function QuickActionsProvider(props: any) {
    const router = useRouter();
    const { myshopify_domain, dataLoaded } = useLoop();
    const [axios] = useAxios();
    const toasts = useToast();
    const [_isLoading, setisLoading] = useState(true);
    const [contextValue, setcontextValue] = useState({ quickAction: null, quickActionKey: null, selectedSegment: null });
    const [_mounted, setMounted] = useState(false);

    const loadData = async (displayToast: any = true) => {
        setisLoading(true);
        try {
            if (router.query.quickActionUuid) {
                const _params: any = {
                    quickActionUuid: router.query.quickActionUuid,
                };
                const { data }: any = await axios.get(`${process.env.NEXT_PUBLIC_LOOP_BACKEND}/api/customer/v2/get_quick_action?` + new URLSearchParams(_params));
                if (data.success === false && data.message === "No eligible segment found") {
                    const currentUrl = new URL(window.location.href);
                    currentUrl.searchParams.delete('uuid');
                    window.location.href = currentUrl.toString();
                    return;
                }

                const _quickAction = data.data;
                const _quickActionKey = data.data.actionKey;
                const _selectedSegment = data.data.eligibleSegmentId;

                // Handle usage limit for campaign quick actions
                if (_quickAction.actionKey && _quickAction.actionCategory === 'CAMPAIGN' && campaignWithUsageLimitEnabled.includes(_quickAction.actionKey)) {
                    if (Number(_quickAction.customerUsageCount) >= Number(_quickAction.campaignMaxUsageCount)) {
                        if (displayToast) {
                            toasts.open({
                                message: translate('campaign_action_completed_message'),
                                time: 10000,
                                type: "failure"
                            });
                        }
                        setcontextValue({
                            quickAction: null,
                            quickActionKey: null,
                            selectedSegment: null
                        });
                        setisLoading(false);
                        return;
                    } else {
                        setcontextValue({
                            quickAction: _quickAction,
                            quickActionKey: _quickActionKey,
                            selectedSegment: _selectedSegment,
                        });
                    }
                } // Handle completed quick actions and campaigns which are not in usage limit check
                else if (_quickAction.isCompleted && displayToast) {
                    toasts.open({ message: translate('quick_action_completed_message'), time: 10000, type: "failure" });
                    setcontextValue({
                        quickAction: _quickAction.isCompleted ? null : _quickAction,
                        quickActionKey: _quickAction.isCompleted ? null : _quickActionKey,
                        selectedSegment: _quickAction.isCompleted ? null : _selectedSegment
                    });
                } else {
                    setcontextValue({
                        quickAction: _quickAction.isCompleted ? null : _quickAction,
                        quickActionKey: _quickAction.isCompleted ? null : _quickActionKey,
                        selectedSegment: _quickAction.isCompleted ? null : _selectedSegment
                    });
                }
            }
        } catch (error) {
            handleError(error, 'loadData', 'quick-actions-provider', {
                myshopify_domain
            });
        }
        setisLoading(false);
    }

    useEffect(() => {
        setMounted(true);
        return () => setMounted(false);
    }, []);

    useEffect(() => {
        if (router.isReady && dataLoaded) {
            loadData();
        }
    }, [router, dataLoaded]);

    return (
        <QuickActionsContext.Provider value={{ ...contextValue, loadQuickAction: loadData }}>
            {!_isLoading ? (
                props.children
            ) : (
                <div className="loop-background" id="loop-background">
                    {" "}
                    <Loader />
                </div>
            )}
        </QuickActionsContext.Provider>
    );
}

export const useQuickActions = () => useContext(QuickActionsContext);
